module.exports = __webpack_public_path__ + "media/img/pages/profile/csl ger 3-57ef3c7aa8f511d1ae0a4c5eadb34c80.jpg";